import React from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import VehicleCategoryService from "src/service/vehicleCategory";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Vehicle Category",
  },
];

const validationSchema = yup.object({
  vehicle_name: yup
    .string("Vehicle Category Name")
    .matches(
      /^[a-zA-Z ]+$/,
      "Vehicle Category Name should only contain alphabet"
    )
    .min(2, "Vehicle Category Name should be of minimum 2 characters in length")
    .max(
      30,
      "Vehicle Category Name should be of maximum 30 characters in length"
    )
    .required("Vehicle Category Name is required"),
});

const AddvehicleCategory = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const initialValues = {
    // admin_id: sessionData.data.id,
    vehicle_name: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));

        try {
          const res = await VehicleCategoryService.addVehicleCategory(values);
          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/vehicle");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Add Vehicle Category" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Vehicle Category
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/vehicle");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/*   ==== manufacturer name  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="vehicle_name">
                Vehicle Category Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="vehicle_name"
                name="vehicle_name"
                type="text"
                value={values.vehicle_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.vehicle_name && Boolean(errors.vehicle_name)}
                helperText={touched.vehicle_name && errors.vehicle_name}
                variant="outlined"
                placeholder="Enter vehicle name"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddvehicleCategory;
